var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("router-view"),
      _vm._v(" "),
      _vm.showFooter
        ? _c("div", { staticClass: "footer" }, [
            _c("div", { staticClass: "footer-line line-1px" }),
            _vm._v(" "),
            _c("div", { staticClass: "footer-notes" }, [
              _c("div", { staticClass: "more-info" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://everjournal.life/terms-and-conditions-cn.html",
                      target: "_blank"
                    }
                  },
                  [_vm._v("条款")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://everjournal.life/privacy-policy-cn.html",
                      target: "_blank"
                    }
                  },
                  [_vm._v("隐私")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.handleClickFooter("/feature")
                      }
                    }
                  },
                  [_vm._v("下载")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.handleClickFooter("/price")
                      }
                    }
                  },
                  [_vm._v("会员")]
                )
              ]),
              _vm._v(" "),
              _vm._m(0)
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "legal" }, [
      _c("div", { staticClass: "signature-info" }, [
        _vm._v("made with "),
        _c("span", { staticClass: "text-heart" }, [_vm._v("❤")]),
        _vm._v(" by xiangzi tech.")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "icp-info" }, [
        _vm._v("© 2022 巷子科技 "),
        _c(
          "a",
          { attrs: { href: "https://beian.miit.gov.cn/", target: "_blank" } },
          [_vm._v("浙ICP备18015514号-2")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }